import { render, staticRenderFns } from "./CTFNatasSolution.vue?vue&type=template&id=08c2cbd6&"
import script from "./CTFNatasSolution.vue?vue&type=script&lang=js&"
export * from "./CTFNatasSolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports